import * as React from 'react'

import { KEY_POSITIONS } from './constants'
import Sketch from './Sketch'
import { showKeyIndicator } from './helpers'

const getSketch = (width: number, height: number) => (p: any) => {
  class Walker {
    xBias: number = 0
    yBias: number = 0

    private x: number = width / 2
    private y: number = height / 2
    private stepSize = 25

    step(): void {
      this.x = p.constrain(this.x + this.getNewX() * this.stepSize, 0, width)
      this.y = p.constrain(this.y + this.getNewY() * this.stepSize, 0, height)
    }

    display(): void {
      p.stroke(255)
      p.strokeWeight(3)
      p.point(this.x, this.y)
    }

    private getNewX() {
      let randomX = p.random(-1, 1)
      let qualifierX = p.random(0, 1)
      if (this.xBias > 0 && randomX < 0 && qualifierX < this.xBias) {
        randomX = -randomX
      } else if (this.xBias < 0 && randomX > 0 && qualifierX < -this.xBias) {
        randomX = -randomX
      }

      return randomX
    }

    private getNewY() {
      let randomY = p.random(-1, 1)
      let qualifierY = p.random(0, 1)
      if (this.yBias > 0 && randomY < 0 && qualifierY < this.yBias) {
        randomY = -randomY
      } else if (this.yBias < 0 && randomY > 0 && qualifierY < -this.yBias) {
        randomY = -randomY
      }

      return randomY
    }
  }

  // Lower is faster
  const disappearanceRate = 1

  let w: Walker

  p.setup = () => {
    p.createCanvas(width, height)
    w = new Walker()
  }

  p.draw = () => {
    if (!w) { return }

    const frameRate = p.frameRate()
    const alpha = frameRate ? 255 / frameRate / disappearanceRate : 1
    p.background(0, 0, 0, alpha)
    w.step()
    w.display()
  }

  p.keyPressed = () => {
    if (!w) { return }

    const position = KEY_POSITIONS[p.key.toLowerCase()]
    if (position) {
      const { x, y } = position
      w.xBias = x - 0.5
      w.yBias = y - 0.5

      showKeyIndicator(p)
    }
  }
}

const prompt = <React.Fragment>Direct the dots <br />with your keyboard</React.Fragment>

const Meander = () => <Sketch getSketch={getSketch} prompt={prompt} />

export default Meander



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Meander.tsx